module.exports = __webpack_public_path__ + "7e0279f6a13b02a950e0b183e1eeaabe.MP3";